import React, { Component } from "react";
import { connect } from "react-redux";
import { func, string } from "prop-types";
import { MicrosoftApi } from "services/microsoft";
import { DataCenterApi } from "services/datacenter";
import { findIana } from "windows-iana";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import CreateCalendarEvent from "sub_components/Common/CreateCalendarEvent";
import set from "date-fns/set";
import isAfter from "date-fns/isAfter";
import areIntervalsOverlapping from "date-fns/areIntervalsOverlapping";
import MaskedInput from "react-text-mask";
import add from "date-fns/add";
import {
  CALENDAR_HOURS,
  CALENDAR_END_HOURS,
  TIMEMASK,
} from "utils/Misc/CommonConstants";

class CalendarModal extends Component {
  constructor(props) {
    super(props);
    const tomorrow = add(new Date(), { days: 1 });
    this.state = {
      events: null,
      startOfWeek: null,
      dropdownOpen: false,
      datacenter: this.setLocation(props.location),
      datacenters: null,
      currentTimezone: null,
      selectedDay: tomorrow,
      startdatetime: set(tomorrow, { hours: 9 }),
      enddatetime: set(tomorrow, { hours: 10 }),
      overlapping: false,
      loading: true,
      outHours: false,
      outHoursEndTime: false,
    };
  }

  componentDidMount() {
    this.getDatacenters();
    this.getCalendarView();

    const { type, eventDetails } = this.props;
    if (type === "update" && eventDetails) {
      this.setState({
        startdatetime: eventDetails?.startDateTime?.dateTime,
        enddatetime: eventDetails?.endDateTime?.dateTime,
      });
    }
  }

  setOutHoursTime = (event) => {
    const { startdatetime } = this.props;
    const time = event?.target.value;

    const timeFormat = /^([01]\d|2[0-3]):([0-5]\d)$/;

    if (!timeFormat.test(time)) {
      return; // Exit the function if the input is invalid
    }

    const splitTime = time.split(":");
    const hours = splitTime[0];
    const minutes = splitTime[1];

    const start = set(new Date(startdatetime), { hours, minutes });
    change({ target: { name: "startDateTime", value: start } });
  };

  setOutHoursTimeEnd = (event) => {
    const { enddatetime } = this.props;
    const time = event?.target.value;

    const timeFormat = /^([01]\d|2[0-3]):([0-5]\d)$/;

    if (!timeFormat.test(time)) {
      return; // Exit the function if the input is invalid
    }

    const splitTime = time.split(":");
    const hours = splitTime[0];
    const minutes = splitTime[1];

    const end = set(new Date(enddatetime), { hours, minutes });

    change({ target: { name: "endDateTime", value: end } });
    change({ target: { name: "timeSelected", value: true } });
  };

  getStartOfWeek = (dcs) => {
    const { datacenters } = this.state;
    const { location } = this.props;

    let dcList = null;
    if (!datacenters) {
      dcList = dcs;
    }
    const datacenter = this.setLocation(location);
    const selectedDC = dcList && dcList.filter((dc) => dc.name === datacenter);

    if (selectedDC[0]) {
      const ianaTimeZone = findIana(selectedDC[0]?.timezone);

      const startOfWeek = startOfWeek(new Date(), { locale: ianaTimeZone[0] });

      this.setState({ currentTimezone: selectedDC[0]?.timezone, datacenter });

      return startOfWeek;
    }
  };
  setLocation = (location) => {
    let datacenter = "";
    switch (location) {
      case "Atlanta":
        datacenter = "ATL";
        break;
      case "Huntsville":
        datacenter = "HSV";
        break;
      case "Chattanooga":
        datacenter = "CHA";
        break;
      case "Birmingham":
        datacenter = "BHM";
        break;
      default:
        datacenter = location;
    }
    return datacenter;
  };
  getDatacenters() {
    DataCenterApi.getAllDatacenters()
      .then((response) => {
        const validResponse = response.status === 200 && response.data;

        if (validResponse) {
          // set start of week based off timezone from selected datacenter
          const datacenters = response.data?.datacenters;

          const startOfWeek = this.getStartOfWeek(datacenters);

          this.setState({ datacenters, startOfWeek });
        }
      })
      .catch(() => this.setState({ error: "Error pulling datacenters" }));
  }
  formatEvents = (events) => {
    const formattedEvents = [];

    if (!events) {
      return [];
    }

    events.map((element, index) => {
      const startdatetime = new Date(element?.startDateTime?.dateTime);
      const enddatetime = new Date(element?.endDateTime?.dateTime);

      const start = new Date(
        startdatetime.getFullYear(),
        startdatetime.getMonth(),
        startdatetime.getDate(),
        startdatetime.getHours(),
        startdatetime.getMinutes()
      );
      const end = new Date(
        enddatetime.getFullYear(),
        enddatetime.getMonth(),
        enddatetime.getDate(),
        enddatetime.getHours(),
        enddatetime.getMinutes()
      );
      if (element?.status === "BUSY") {
        formattedEvents.push({
          id: index,
          title: "UNAVAILABLE",
          allDay: false,
          start,
          end,
        });
      }
    });
    return formattedEvents;
  };

  getCalendarView() {
    const { datacenter } = this.state;
    const { startdatetime } = this.props;
    const date = new Date(startdatetime);

    const params = {
      datacenter,
      startDate: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        hour: 9,
        minute: 0,
      },
      endDate: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        hour: 17,
        minute: 0,
      },
    };

    MicrosoftApi.getCalendarView(params)
      .then((response) => {
        const validResponse = response.status === 200 && response.data;

        if (validResponse) {
          const formatedEvents = this.formatEvents(response.data?.events);
          this.setState({ events: formatedEvents, loading: false });
        }
      })
      .catch(() =>
        this.setState({ error: "Error pulling events", loading: false })
      );
  }

  refreshCalendarView = () => {
    this.setState({ events: null });
    this.getCalendarView();
  };

  onSelectedEndTime = (endTime) => {
    const { events } = this.state;
    const { finishedCallback } = this.props;

    if (events && events.length !== 0) {
      const currentSelected = events.filter(
        (event) => event.title === "selected"
      );
      const filteredEvents = events.filter(
        (event) => event.title !== "selected"
      );
      const valid = this.checkEventValid(
        events,
        currentSelected[0]?.start,
        endTime
      );
      if (currentSelected && valid) {
        this.setState({
          events: [
            ...filteredEvents,
            {
              start: currentSelected[0]?.start,
              end: endTime,
              title: "selected",
            },
          ],
          overlapping: false,
          startdatetime: currentSelected[0]?.start,
          enddatetime: endTime,
        });

        finishedCallback(currentSelected[0]?.start, endTime);
      } else {
        this.setState({ overlapping: true });
      }
    }
  };

  checkEventValid = (events, start, end) => {
    const overlaps = [];
    const endOfDay = set(start, { hours: 17 });

    events.map((event) => {
      if (
        isAfter(end, endOfDay) ||
        areIntervalsOverlapping(
          { start: new Date(start), end: new Date(end) },
          { start: new Date(event?.start), end: new Date(event?.end) }
        )
      ) {
        overlaps.push(true);
      }
    });
    if (overlaps.length !== 0) {
      return false;
    } else {
      return true;
    }
  };

  setOutOfHoursCheckBox = () => {
    const checkBox = document.getElementById("outHoursCheckEndTime");
    if (checkBox?.checked === true) {
      this.setState({ outHoursEndTime: true });
    } else {
      this.setState({ outHoursEndTime: false });
    }
  };

  setOutOfHours = () => {
    const checkBox = document.getElementById("outHours");
    if (checkBox?.checked === true) {
      this.setState({ outHours: true });
    } else {
      this.setState({ outHours: false });
    }
  };

  setOutHoursTime = (event) => {
    const { startdatetime } = this.state;
    const time = event?.target.value;

    const timeFormat = /^([01]\d|2[0-3]):([0-5]\d)$/;

    if (!timeFormat.test(time)) {
      return; // Exit the function if the input is invalid
    }

    const splitTime = time.split(":");
    const hours = splitTime[0];
    const minutes = splitTime[1];

    const start = set(new Date(startdatetime), { hours, minutes });
    this.setState({ startdatetime: start });
  };

  setOutHoursTimeEnd = (event) => {
    const { enddatetime } = this.state;
    const time = event?.target.value;

    const timeFormat = /^([01]\d|2[0-3]):([0-5]\d)$/;

    if (!timeFormat.test(time)) {
      return; // Exit the function if the input is invalid
    }

    const splitTime = time.split(":");
    const hours = splitTime[0];
    const minutes = splitTime[1];

    const end = set(new Date(enddatetime), { hours, minutes });

    this.setState({ enddatetime: end });
  };

  onTimeSelect = (selected, index) => {
    const { startdatetime, setStartTimeSelected } = this.props;
    const selectedHour = document.querySelector(`.hour-button.selected`);
    const newSelectedHour = document.getElementById(`hour-button-${index}`);
    if (selectedHour) {
      selectedHour.classList.remove("selected");
    }
    if (newSelectedHour) {
      newSelectedHour.classList.add("selected");
    }

    const hours = Math.floor(selected?.value);
    const minutes = selected?.value % 1 === 0.5 ? 30 : 0;

    const start = set(new Date(startdatetime), {
      hours,
      minutes,
    });

    setStartTimeSelected(start);
  };

  onEndTimeSelect = (selected, index) => {
    const { enddatetime, setEndTimeSelected } = this.props;
    const selectedHour = document.querySelector(`.end-hour-button.selected`);
    const newSelectedHour = document.getElementById(`end-hour-button-${index}`);
    if (selectedHour) {
      selectedHour.classList.remove("selected");
    }
    if (newSelectedHour) {
      newSelectedHour.classList.add("selected");
    }

    const hours = Math.floor(selected?.value);
    const minutes = selected?.value % 1 === 0.5 ? 30 : 0;

    const end = set(new Date(enddatetime), {
      hours,
      minutes,
    });

    setEndTimeSelected(end);
  };

  render() {
    const { loading, datacenter, outHours, outHoursEndTime } = this.state;
    const {
      setModalContent,
      setEvent,
      event,
      type,
      eventDetails,
      auth_status,
      guestEmail,
      updateEventCallback,
      setNewEndDateTime,
      setNewStartDateTime,
      resetSelectedDateTime,
      setNewStartTime,
      setNewEndTime,
      startdatetime,
      enddatetime,
      location,
      setAttendees,
      showStartDateTimeClock,
      showStart,
      breakpoint,
    } = this.props;
    const min = new Date();
    min.setHours(9, 0, 0);
    const max = new Date();
    max.setHours(17, 0, 0);
    const overlaps = [];

    return (
      <div className="calendar-modal-wrapper">
        <ScrollView>
          <div className="calendar-modal">
            <CreateCalendarEvent
              selectedDC={datacenter}
              setModalContent={setModalContent}
              refreshCalendarView={this.refreshCalendarView}
              startdatetime={startdatetime}
              enddatetime={enddatetime}
              setNewEndDateTime={setNewEndDateTime}
              setNewStartDateTime={setNewStartDateTime}
              resetSelectedDateTime={resetSelectedDateTime}
              setNewStartTime={setNewStartTime}
              setNewEndTime={setNewEndTime}
              setEvent={setEvent}
              event={event}
              type={type}
              location={location}
              eventDetails={eventDetails}
              auth_status={auth_status}
              guestEmail={guestEmail}
              updateEventCallback={updateEventCallback}
              setAttendees={setAttendees}
              showStartDateTimeClock={showStartDateTimeClock}
              showStart={showStart}
              breakpoint={breakpoint}
            />
            <div className="calendar-week-wrapper">
              <div className="calendar-week-header">
                <div className="event-time-picker">
                  <div className="labels22">
                    {outHours
                      ? "Input the requested start time"
                      : "Select a start time"}
                  </div>
                  <div className="hours-wrapper">
                    {!loading &&
                      !outHours &&
                      CALENDAR_HOURS.map((hour, index) => {
                        return (
                          <div
                            className={"hour-button"}
                            id={`hour-button-${index}`}
                            data-cy={`hour-button-${index}`}
                            onClick={() => this.onTimeSelect(hour, index)}
                          >
                            <div className="label body10">{hour?.label}</div>
                          </div>
                        );
                      })}
                    {outHours && (
                      <div className="body10">
                        <MaskedInput
                          id="appt"
                          name="appt"
                          mask={TIMEMASK}
                          onChange={this.setOutHoursTime}
                        />
                      </div>
                    )}
                    {loading && !outHours && (
                      <div className="loading body10">
                        Loading available time slots...
                      </div>
                    )}
                  </div>
                  <div className="out-of-hours">
                    <div className="body10">After hours ? (5PM to 8AM)</div>
                    <input
                      type="checkbox"
                      id="outHours"
                      onClick={this.setOutOfHours}
                    />
                  </div>
                  {overlaps.length === 8 && (
                    <div className="info-message labels22">
                      The desired data center is not accepting guests on this
                      day, or at certain times, due to maintenance or
                      unavailable staff. Please select a different day , or
                      contact support for additional help.
                    </div>
                  )}
                </div>
              </div>
              <div className="event-time-picker">
                <div className="labels22">
                  {outHoursEndTime
                    ? "Input the requested end time"
                    : "Select an end time"}
                </div>
                <div className="hours-wrapper">
                  {!outHoursEndTime &&
                    CALENDAR_END_HOURS.map((hour, index) => {
                      return (
                        <div
                          className={"end-hour-button"}
                          id={`end-hour-button-${index}`}
                          data-cy={`end-hour-button-${index}`}
                          onClick={() => this.onEndTimeSelect(hour, index)}
                        >
                          <div className="label body10">{hour?.label}</div>
                        </div>
                      );
                    })}
                  {outHoursEndTime && (
                    <div className="body10">
                      <MaskedInput
                        id="appt"
                        name="appt"
                        mask={TIMEMASK}
                        onChange={this.setOutHoursTimeEnd}
                      />
                    </div>
                  )}
                </div>
                <div className="out-of-hours">
                  <div className="body10">After hours ? (5PM to 8AM)</div>
                  <input
                    type="checkbox"
                    id="outHoursCheckEndTime"
                    onClick={this.setOutOfHoursCheckBox}
                  />
                </div>
              </div>
            </div>
          </div>
        </ScrollView>
      </div>
    );
  }
}

CalendarModal.propTypes = {
  location: string,
  closeModal: func,
  finishedCallback: func,
  setEvent: func,
  type: string,
};

CalendarModal.defaultProps = {
  location: "",
  closeModal: () => {},
  finishedCallback: () => {},
  setEvent: () => {},
  type: "create",
};

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
  };
}

export default connect(mapStateToProps, null)(CalendarModal);
